import React, { useMemo } from 'react';
import { Skeleton } from 'antd';
import styles from './index.module.scss';
const ListLoading = props => {
    const { loading = false, isUseRealList, pageSize } = props;
    const defaultListLoading = useMemo(() => {
        const res = [];
        for (let i = 0; i < pageSize; i++) {
            res.push(React.createElement("div", { style: { height: '75px' }, key: i },
                React.createElement(Skeleton, { active: true, key: i, loading: true, avatar: true, paragraph: { rows: 1 } })));
        }
        return res;
    }, [pageSize]);
    return (React.createElement("div", { hidden: !loading, className: styles.loadingWrap, style: {
            width: '100%',
            height: isUseRealList ? '100%' : '100vh',
            minHeight: '100vh',
            overflow: 'hidden',
            padding: '10px 5px',
            position: 'absolute',
            top: 0,
            left: 0,
        } }, defaultListLoading));
};
export default ListLoading;
